import { ITemplateAppTech } from "api/types/_campaign";
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from "common/toast";
import DropdownOption from "components/Common/DropdownOption";
import { useFormik } from "formik";
import { APP_TECH_TEMPLATE_TYPE } from "helpers/constans";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Col, Input, Label, Modal, ModalBody, ModalHeader, Row, Spinner } from "reactstrap";
import { postTemplateAppTech, putTemplateAppTech } from "store/campaign/thunk";
import * as Yup from "yup";

export interface Props {
    isOpen?: boolean;
    detail?: ITemplateAppTech | null,
    appTechs?: { label: string, value: string, name: string }[],
    partners?: { label: string, value: string, name: string, partner_codes?: any[], partner_reporters?: any[] }[],
    onClose?: () => void
    triggerRefresh?: (type?: string) => void;
}

const CampaignForm = ({
    isOpen = false,
    detail = null,
    appTechs = [],
    partners = [],
    onClose,
    triggerRefresh
}: Props) => {
    const { t, i18n } = useTranslation();

    const APP_TECH_OPTIONS_LANG: any = appTechs;

    const MEDIA_OPTIONS_LANG: any = partners;

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [isDetailLoading, setIsDetailLoading] = useState<boolean>(false);

    const onCloseClick = () => {
        onClose && onClose();
    }

    const handleSubmit = async (values: any) => {
        try {
            setIsLoading((_prev) => true);
            const data = {
                ...(!!detail?.id ? {} : {
                    type: APP_TECH_TEMPLATE_TYPE.TITLE,
                    app_tech_id: Number(values?.apptech_id?.value),
                }),
                media_id: Number(values?.media_id?.value),
                name: values?.content || '',
                content: values?.content || '',
            };

            const response: any = !!detail?.id ? await putTemplateAppTech(detail?.id, data) : await postTemplateAppTech(data);
            if (response?.code === 200) {
                setIsLoading((_prev) => false);
                toast(
                    `${t("The process has been completed.")}`,
                    CONFIG_OPTION_TOAST_NORMAL
                );
                triggerRefresh && triggerRefresh();
            } else {
                setIsLoading((_prev) => false);
                toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIsLoading((_prev) => false);
            toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };

    const validationSchema = Yup.object({
        apptech_id: Yup.object().shape({
            label: Yup.string(),
            value: Yup.string(),
        }).required(`${t("This is required")}`),
        media_id: Yup.object().shape({
            label: Yup.string(),
            value: Yup.string(),
        }).required(`${t("This is required")}`),
        content: Yup.string().required(`${t("This is required")}`),
    });

    const formik = useFormik({
        initialValues: {
            apptech_id: null,
            media_id: null,
            content: '',
        },
        validationSchema,
        onSubmit: handleSubmit,
    });

    useEffect(() => {
        const handleCallAllOption = async () => {
            try {
                if (!!detail?.id) {
                    const _content = detail?.content || [];
                    const _apptech = { value: String(detail?.apptech?.id), label: detail?.apptech?.name };
                    const _media = { value: String(detail?.partner?.id), label: detail?.partner?.name };
                    setTimeout(() => {
                        formik.setFieldValue('content', _content);
                        formik.setFieldValue('apptech_id', _apptech);
                        formik.setFieldValue('media_id', _media);
                    }, 300);
                } else {
                    formik.setFieldValue('content', '');
                    formik.setFieldValue('apptech_id', null);
                    formik.setFieldValue('media_id', null);
                    setTimeout(() => {
                        formik.setErrors({});
                    }, 300);

                }
            } catch (error: any) {
                // setIsLoadingDetail((_prev) => false);

                return error;
            }
        };
        handleCallAllOption();
    }, [JSON.stringify(detail)]);

    return (
        <React.Fragment>
            <Modal
                isOpen={isOpen}
                centered={true}
                size="md"
                className={`border-header-footer`}
                scrollable={false}
                toggle={onCloseClick}
                keyboard={true}
            >
                <ModalHeader toggle={onCloseClick} className="modal-title-flex-grow-1">
                    <div className="d-flex flex-column gap-0 gap-sm-2 fs-18 fs-md-20">
                        <div className="flex-grow-1">
                            <>{!!detail?.id ? t('Button Update Template') : t('Button Create Template')}</>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody className="position-relative">
                    <div>
                        <form onSubmit={formik.handleSubmit}>
                            <Row>
                                <Col sm={12} className="mb-3">
                                    <Label htmlFor="apptech_id" className="form-label">{t('App')} <span className="text-danger"> *</span></Label>
                                    <DropdownOption
                                        name="apptech_id"
                                        dataList={APP_TECH_OPTIONS_LANG}
                                        placeholder={`${t("App")}...`}
                                        className="search-filter-category-type dropdown-status-rounded"
                                        classNamePrefix="name-prefix"
                                        initialValue={formik?.values?.apptech_id || null}
                                        onChangeSelect={(e: any) => {
                                            formik.setFieldValue('apptech_id', e)
                                        }}
                                        isHasOptionAll={false}
                                        // isHaveMoreInfo={true}
                                        disabled={isDetailLoading || !!detail?.id}
                                    />
                                    {formik.touched.apptech_id && formik.errors.apptech_id ? (
                                        <div className="text-danger mt-2">{formik.errors.apptech_id}</div>
                                    ) : null}
                                </Col>
                                <Col sm={12} className="mb-3">
                                    <Label htmlFor={`media_id`} className="form-label">{t('Media')}<span className="text-danger"> *</span> </Label>
                                    <DropdownOption
                                        name={`media_id`}
                                        dataList={MEDIA_OPTIONS_LANG}
                                        placeholder={`${t("Media")}...`}
                                        className="search-filter-category-type dropdown-status-rounded"
                                        classNamePrefix="name-prefix"
                                        initialValue={formik?.values?.media_id || null}
                                        isHaveMoreInfo={true}
                                        onChangeSelect={(e: any) => {
                                            formik.setFieldValue(`media_id`, e)
                                        }}
                                        isHasOptionAll={false}
                                        disabled={isDetailLoading}
                                    />
                                    {formik.touched.media_id && formik.errors.media_id ? (
                                        <div className="text-danger mt-2">{formik.errors.media_id}</div>
                                    ) : null}
                                </Col>
                                <Col sm={12} className="mb-4">
                                    <Label htmlFor="content" className="form-label">{t('Title')} <span className="text-danger"> *</span></Label>
                                    <Input
                                        name="content"
                                        type="textarea"
                                        className="form-control"
                                        rows={3}
                                        id="content"
                                        placeholder={t('Title')}
                                        value={formik?.values?.content}
                                        onChange={(event: any) => formik.setFieldValue('content', event?.target?.value)}
                                    />
                                    {formik.touched.content && formik.errors.content ? (
                                        <div className="text-danger mt-2">{formik.errors.content}</div>
                                    ) : null}

                                    <div className="text-muted fs-12 mt-2">
                                        {t("{month} and {date}, {hour} are converted to the current month and day, respectively.")} <br />
                                        {t("Example: {month} 월 {date} 일 {hour} 시 ->  3 월 4 일 9 시")}
                                    </div>
                                </Col>
                                <Col sm={12} className="mb-2" >
                                    <div className="d-flex gap-3 justify-content-end align-item-center">
                                        <button
                                            className="btn btn-primary fs-14 px-1 d-flex justify-content-center align-item-center"
                                            type="submit"
                                            style={{ width: '160px' }}
                                            disabled={isLoading}
                                        >
                                            {isLoading && <span style={{ transform: 'translateY(1px)' }} className="me-1"><Spinner size="sm"></Spinner></span>}<span>{
                                                !!detail?.id ? t('Button Update Template') : t('Button Create Template')
                                            }</span>
                                        </button>
                                        <button
                                            className="btn btn-secondary fs-14 px-1 d-flex justify-content-center align-item-center"
                                            type="button"
                                            onClick={onCloseClick}
                                            style={{ width: '85px' }}
                                        >
                                            <i className="ri-close-fill" style={{ lineHeight: '22px' }} /> <span className="ms-1">{t("Button Close")}</span>
                                        </button>
                                    </div>
                                </Col>
                            </Row>
                        </form>
                    </div>
                </ModalBody>
            </Modal>
        </React.Fragment >
    );
};

export default CampaignForm;

